import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { MediaTypeEnum, MediaVideoContentTypeEnum } from 'constants-media';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    default: MediaTypeEnum.Video,
    validators: [
      {
        name: 'In',
        value: [MediaTypeEnum.Video],
      },
    ],
  },
  contentType: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: Object.values(MediaVideoContentTypeEnum),
      },
    ],
  },
};

export class VideoType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Video';

  friendlyName = 'Video';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];
  properties = properties;

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }
}

const videoTypeDefinition = new VideoType();

Types.addBaseType(videoTypeDefinition);
export { videoTypeDefinition };
